export default Object.freeze({
  AWS: 'aws',
});
